/* unplugin-vue-components disabled */import script from "./CourseAppointmentEmployeeSelector.vue?vue&type=script&setup=true&lang=js"
export * from "./CourseAppointmentEmployeeSelector.vue?vue&type=script&setup=true&lang=js"

import "./CourseAppointmentEmployeeSelector.vue?vue&type=style&index=0&id=795cc56f&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-795cc56f"]])

export default __exports__